import styled from 'styled-components';

import { ContentBanner } from '@xing-com/banner';
import { TextButton } from '@xing-com/button';
import { spaceL, spaceXL } from '@xing-com/tokens';

const AuthorInfoBoxContainer = styled(ContentBanner)`
  display: block;
  padding: ${spaceXL};
`;

const AuthorInfoBoxContentContainer = styled.div`
  margin-bottom: ${spaceXL};
`;

const AuthorInfoBoxFacePileContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${spaceL};
`;

const AuthorInfoBoxFacePileMoreContacts = styled(TextButton)`
  margin-left: ${spaceL};
`;

export const Styled = {
  AuthorInfoBoxContainer,
  AuthorInfoBoxContentContainer,
  AuthorInfoBoxFacePileContainer,
  AuthorInfoBoxFacePileMoreContacts,
};
